var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.chartData && _vm.chartOptions && !_vm.loading)?_c('BarChart',{staticClass:"r",attrs:{"type":"R","chart-data":_vm.chartData,"chart-options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }